<template>
    <layout :home_link="home_link">
        <a-breadcrumb class="px-4 pb-0 pt-4" :class="{ 'lg:hidden': !isEpicvaultEnabled, '': isEpicvaultEnabled }">
            <a-breadcrumb-item data-cy="breadcrumb-main">
                <a @click="$router.go(-1)">
                    <template v-if="isEpicvaultEnabled">
                        {{ $t('globals.navigation.header.claims_view.alt_title') }}
                    </template>
                    <template v-else>
                        {{ $t('globals.navigation.header.claims_view.title') }}
                    </template>
                </a>
            </a-breadcrumb-item>
            <a-breadcrumb-item data-cy="breadcrumb-sub">
                {{ $t('globals.navigation.header.claims_view.sub_title') }}
            </a-breadcrumb-item>
        </a-breadcrumb>

        <div class="shadow-xl claims-details">
            <!-- show the belize layout of orinco is set -->
            <view-belize
                v-if="claimsDetailLayout === 'orinco'"
                data-cy="claim-view"
                :claim="claim"
                :claim_id="claim_id"
            />
            <!-- else default to the normal layout -->
            <view-default v-else data-cy="claim-view" :claim="claim" :claim_id="claim_id" />
        </div>
    </layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue';
import ViewDefault from '@/components/views/claims/Default.vue';
import ViewBelize from '@/components/views/claims/Belize.vue';

export default {
    components: {
        Layout,
        ViewDefault,
        ViewBelize,
    },
    data() {
        return {
            claim_id: this.$route.params.id,
            claim: {
                third_party_claimants: [],
            },
            home_link: {
                to: () => {
                    this.$router.go(-1);
                },
                label: this.$t('globals.navigation.header.claims_view.title'),
                default: false,
                module: 'claim',
            },
        };
    },
    computed: {
        isEpicvaultEnabled() {
            return this.$store.state.system.is_epicvault_enabled ? true : false;
        },
        claimsDetailLayout() {
            return this.$store.state.user.claims_detail_layout;
        },
    },
    mounted() {
        const claim_id = this.$route.params.id;

        this.$http
            .get('/api/claims/' + claim_id)
            .then((response) => {
                let claimData = {
                    ...response.data.data,
                    is_hide_claim_description: response.data.data.is_hide_claim_description == 1 ? true : false,
                };
                this.claim = claimData;
            })
            .catch((error) => {
                if (error.response.status == 404) {
                    this.$router.push({
                        name: 'not-found',
                    });
                } else {
                    this.$notification.error({
                        message: this.$t('globals.global.notifications.error.any', { code: 'CVCVIEW01' }),
                    });
                }
            });
    },
};
</script>
